
const errors = [];
errors[77889]="User Not found";

export default errors; 